import { render, staticRenderFns } from "./CkEditor.vue?vue&type=template&id=176bf896&"
import script from "./CkEditor.vue?vue&type=script&lang=js&"
export * from "./CkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports